import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { SettingsService } from '../services/settings.service';

@Directive({
  selector: '[betaFeature]',  // Applies the directive to any element with this attribute
  standalone: true
})
export class BetaFeatureDirective implements OnInit {

  @Input() betaFeatureField: any; // Accept an optional field input to manage field-specific behavior

  constructor(
    private settingService: SettingsService,  // Inject the service to check beta mode
    private el: ElementRef  // ElementRef is used to manipulate the DOM element where the directive is applied
  ) { }

  ngOnInit() {
    // Get the global beta mode status from the SettingsService
    let betaMode = this.settingService.isBetaMode();

    if (betaMode === true) {
      // If beta mode is enabled globally, do nothing and keep the element visible
    } else if (!this.betaFeatureField) {
      // If beta mode is off and no field is provided, hide the element by setting display to "none"
      this.el.nativeElement.style.display = "none";
    }

    // If beta mode is off and the field is provided with a defined betaFeature property,
    // set the field's hide property to true, which can be used to hide the field in the UI
    if (!betaMode && this.betaFeatureField &&
      this.betaFeatureField.props.betaFeature !== undefined &&
      this.betaFeatureField.props.betaFeature !== null) {
      this.betaFeatureField.props.hide = true; // Set the field's hide property to true
    }
  }
}